import { Button } from "antd";
import React from "react";
import { RiPhoneFill, RiMessage2Fill, RiAtFill } from "react-icons/ri";
import { ImLocation2 } from "react-icons/im";

import { profileImgPlaceholder } from "../../../assets/images";
import { Domain, request } from "../../../config/API";
import { COLORS } from "../../../config/theme";
import renderSocialIcon from "./rederSocialIcons";
import Theme1 from "../profileThemes/Theme1/Theme1";
import Theme2 from "../profileThemes/Theme2/Theme2";
import Theme3 from "../profileThemes/Theme3/Theme3";
import Theme4 from "../profileThemes/Theme4/Theme4";
import Theme5 from "../profileThemes/Theme5/Theme5";
import Theme6 from "../profileThemes/Theme6/Theme6";
import Theme7 from "../profileThemes/Theme7/Theme7";
import Theme8 from "../profileThemes/Theme8/Theme8";
import Theme9 from "../profileThemes/Theme9/Theme9";
import Theme10 from "../profileThemes/Theme10/Theme10";
import Theme0 from "../profileThemes/Theme0/Theme0";

const ThemeSelector = (
  preset,
  vCard,
  isPreview,
  downloadVcfFile,
  setShowExchangeCard
) => {
  switch (preset) {
    case 1:
      return (
        <Theme1
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );

    case 2:
      return (
        <Theme2
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 3:
      return (
        <Theme3
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 4:
      return (
        <Theme4
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 5:
      return (
        <Theme5
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 6:
      return (
        <Theme6
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 7:
      return (
        <Theme7
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 8:
      return (
        <Theme8
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );

    case 9:
      return (
        <Theme9
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    case 10:
      return (
        <Theme10
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
    default:
      return (
        <Theme0
          vCard={vCard}
          isPreview={isPreview}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      );
  }
};
const Header = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    selectedTheme,
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
  } = vCard;
  const handleLinkClicked = (type) => {
    const data = { type, portalId: owner };
    request
      .post("qr/postLinkClicked", data)
      .then(async (res) => {})
      .catch((e) => {
        console.log("post click error=>", e);
      });
  };
  return (
    <div
      // className="body"
      style={{
        background: pColor ? pColor : primaryColor,
        // borderTopRightRadius: bgImage ? 0 : 8,
        // borderTopLeftRadius: bgImage ? 0 : 8,
        // borderBottomLeftRadius: 8,
        // borderBottomRightRadius: 8,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        {ThemeSelector(
          selectedTheme,
          vCard,
          isPreview,
          downloadVcfFile,
          setShowExchangeCard
        )}
      </div>

      {false && (
        <div
          className="header"
          style={{
            height: "14rem",
            background: bgImage ? `url(${Domain}/data/${bgImage})` : sColor,

            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />
      )}
      {false && (
        <div className="body-container" style={{ paddingBottom: "1rem" }}>
          {/* Profile Image */}

          <img
            draggable={false}
            className="profile-image"
            src={
              profileImage
                ? `${Domain}/data/${profileImage}`
                : profileImgPlaceholder
            }
            alt=""
          />
          {/* username */}
          <h2 className="name mt-20">{`${fNamePrefix || ""} ${fName} ${lName} ${
            lNameSuffix || ""
          }`}</h2>
          {company && <h3 className="sub-info mt-23">{`${company}`}</h3>}
          {/* Direct Contact */}
          <div className="direct-contact">
            <a href={"tel:" + mobile}>
              <RiPhoneFill style={{ color: sColor }} />
            </a>

            <a href={"sms:" + mobile}>
              <RiMessage2Fill style={{ color: sColor }} />
            </a>
            {email && (
              <a href={"mailto:" + email}>
                <RiAtFill style={{ color: sColor }} />
              </a>
            )}
            {address && (
              <a
                href={"https://www.google.com/maps/search/" + address}
                target="_blank"
                rel="noreferrer"
              >
                <ImLocation2 style={{ color: sColor }} />
              </a>
            )}
            <div
              style={{
                alignSelf: "center",
                paddingRight: "4rem",
                paddingLeft: "4rem",
                justifyContent: "center",
                alignContent: "center",
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                alignItems: "stretch",
              }}
            >
              {socialLinks.map((l) => {
                return (
                  <p
                    className="social-links"
                    onClick={() => {
                      window.open("https://" + l?.link, "_blank");
                      handleLinkClicked("sociallink");
                    }}
                    key={l._id}
                  >
                    {renderSocialIcon(l?.name)}
                  </p>
                );
              })}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <Button
                style={{
                  height: "2.5rem",
                  minWidth: !leadEnable ? "20rem" : 0,
                  borderColor: sColor,
                  color: sColor,
                  margin: "1rem",
                  borderWidth: 0,
                  boxShadow: "3px 3px 3px 3px #88888a3a",
                }}
                shape="round"
                size="middle"
                onClick={downloadVcfFile}
              >
                Save My Contact
              </Button>
              {leadEnable && (
                <Button
                  style={{
                    height: "2.5rem",
                    borderColor: sColor,
                    color: sColor,
                    margin: "1rem",
                    borderWidth: 0,
                    boxShadow: "3px 3px 3px 3px #88888a3a",
                  }}
                  shape="round"
                  size="middle"
                  onClick={() => {
                    setShowExchangeCard((prev) => !prev);
                  }}
                >
                  Exchange Contact
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
